export default "__VITE_ASSET__74aa5f75__"